import pic1 from './project1.png';
import pic2 from './project2.png';
import pic3 from './project3.png';
import pic4 from './project4.png';

export default {
    pic1,
    pic2,
    pic3,
    pic4
};
